module.exports = __webpack_public_path__ + "static/media/sidebar6.9e40bab5.jpg";